import { css, Interpolation, Theme } from "@emotion/react"

export const alert: Interpolation<Theme> = css`
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 3;
`
